import { useSuspenseQuery } from '@tanstack/react-query'

import { invariant } from '@marketplace-web/messaging/messaging-util'

import { purchasesCheckAvailability } from '../api'
import { errors } from '../utils'
import queryClient from '../query-client'

const MOCK_RESPONSE = Promise.resolve({
  purchase: {
    purchase_available: true,
    user: { buy: { available: true, unavailable_reason: null } },
    items: { buy: { available: true, unavailable_list: [] } },
  },
})

export default function usePurchasesCheckAvailability(itemIds: ReadonlyArray<number>) {
  const { data } = useSuspenseQuery(
    {
      retry: false,
      queryKey: [purchasesCheckAvailability.queryKey, itemIds.toSorted()],
      // TODO: replace when the API endpoint is functional
      // queryFn: () => purchasesCheckAvailability.post({ item_ids: itemIds as Array<number> }),
      queryFn: () => MOCK_RESPONSE,
      select: response => {
        invariant(!('errors' in response), new errors.UnexpectedErrorsResponse())

        return response.purchase
      },
    },
    queryClient,
  )

  return data
}
